// 患者氏名の突合 (log/193 work-log/6 §5)。
//
// SSoT は起動 URL の deeplink 患者名 (EmbedContext.deeplinkPatientName)。
// 「この iframe セッションが担当する患者」はこれ 1 つで、開いた薬歴の patient_name と
// INIT で親から届く knjName は写しとしてこれに突き合わせる。
//
// 判定は「不一致の証拠があるときだけ true」に倒す:
// - SSoT が無い / 突き合わせ先が無い = 判定不能 → false (黙る)。親の世代 (INIT に何が
//   載るか・そもそも届くか) に依存しないのはこのため。どの世代の親と組んでも誤発火しない
// - 比較は空白除去 + 双方向の包含。back の氏名検索 (icontains) と同じ緩さに合わせる。
//   等値比較にすると NSIPS 側の姓名間空白や外国人氏名の切り詰め (work-log/3 §1) が
//   全て偽陽性になり、ガード自体が信用を失う
//
// 検出できない不一致 (氏名キーの限界。既知制約として受け入れる):
// - 同姓同名の別患者
// - 包含関係にある別患者 (「山田太郎」に対する「小山田太郎」)。この判定の受理集合は
//   back の検索の受理集合を必ず含むため、**検索経由で誤って開いた薬歴に対しては
//   構造的に沈黙する**。このガードが実際に守れるのは「親が別患者へ移った」側で、
//   検索の誤ヒットは back の突合解像度 (完全一致優先・複数ヒット拒否) でしか塞げない
const normalizeName = (value: string | null | undefined): string =>
  (value ?? '').replace(/\s+/g, '')

export const isPatientNameMismatch = (
  expected: string | null | undefined,
  actual: string | null | undefined
): boolean => {
  const a = normalizeName(expected)
  const b = normalizeName(actual)
  if (a === '' || b === '') return false
  return !a.includes(b) && !b.includes(a)
}
